// extracted by mini-css-extract-plugin
module.exports = {"register":"styles_register__0FhHd","pulse":"styles_pulse__O3_va","jump":"styles_jump__HxD83","wiggle":"styles_wiggle__AtEea"};